import { logInfo, logWarn } from 'core-framework/util/LogMessage';
import { stripCultureCode } from 'core/service/Url/Url';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';
import { getRiskifiedBeacon, isRiskifiedBeaconEnabled } from 'core/window/windowService';

const rejectDelay = (error: unknown, timeout = 1000) => {
    return new Promise<unknown>((resolve, reject) => {
        setTimeout(reject.bind(null, error), timeout);
    });
};

const executeWithRetry = (operation: (retries: number) => void, delay = 1000, retries = 3) => {
    let p = Promise.reject<unknown>();

    for (let i = 1; i <= retries; i += 1) {
        p = p.catch(() => operation(i)).catch<unknown>(rejectDelay);
    }
    return p;
};

/**
 * Riskified beacon takes at least 3 seconds to initialize
 */
const notifyRiskifiedWithRetry = (pathName: string, pageTypeId: ActivitiesPageTypes, retryCount: number, printError = false) => {
    const riskifiedBeacon = getRiskifiedBeacon();
    const riskifiedBeaconGo = riskifiedBeacon && riskifiedBeacon.go;
    if (riskifiedBeaconGo) {
        try {
            riskifiedBeaconGo(stripCultureCode(pathName));
        } catch (error) {
            logWarn(`Could not send data to riskified beacon, error: ${error}`, pageTypeId);
        }
    } else if (printError) {
        logInfo(`Riskified beacon is not initialized. Exhausted retry. Beacon: ${JSON.stringify({ beacon: riskifiedBeacon })}, RetryCount: ${retryCount}`, pageTypeId);
    } else {
        throw Error(`Riskified beacon is not initialized. Will retry. RetryCount: ${retryCount}`);
    }
};

export const notifyRiskified = async (pathName: string, pageTypeId: ActivitiesPageTypes, totalRetries = 15) => {
    const isRiskifiedEnabled = isRiskifiedBeaconEnabled();
    if (!isRiskifiedEnabled) return;
    await executeWithRetry(
        (retries: number) => {
            notifyRiskifiedWithRetry(pathName, pageTypeId, retries, retries === totalRetries);
        },
        1000,
        totalRetries,
    );
};
